import React from "react";
import { Monitor, Moon, Sun } from "lucide-react";
import { useLanguage } from "../i18n/LanguageProvider";
import { useTheme } from "../theme/ThemeProvider";

const themeDetails = {
  system: { icon: Monitor, label: "Thème système" },
  light: { icon: Sun, label: "Thème clair" },
  dark: { icon: Moon, label: "Thème sombre" },
};

export default function ThemeSwitcher() {
  const { mode, cycleMode } = useTheme();
  const { t } = useLanguage();
  const currentTheme = themeDetails[mode];
  const Icon = currentTheme.icon;

  return (
    <button
      className="ws-theme-switcher"
      type="button"
      onClick={cycleMode}
      aria-label={t(`${currentTheme.label}. Changer de thème`)}
      title={t(`${currentTheme.label}. Changer de thème`)}
    >
      <Icon size={18} aria-hidden="true" />
      <span>{t(currentTheme.label)}</span>
    </button>
  );
}
